import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "contact-page" }
const _hoisted_2 = {
  key: 0,
  class: "toast"
}
const _hoisted_3 = {
  key: 1,
  class: "confirm-toast-overlay"
}
const _hoisted_4 = { class: "contact-wrapper" }
const _hoisted_5 = { class: "contact-form-card" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "checkbox-label" }

import {ref} from 'vue'
import '@/assets/styles/contact.css'
import axios from 'axios'


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactView',
  setup(__props) {

const submitted = ref(false)
const error = ref('')
const showToast = ref(false)
const toastMessage = ref("")
const showConfirmToast = ref(false)

const form = ref({
  name: '',
  email: '',
  message: '',
  data: false
})

const submitForm = async () => {

  submitted.value = false
  error.value = ''

  try {

    const res = await axios.post("/api/contact", {
      name: form.value.name,
      email: form.value.email,
      message: form.value.message
    })

    submitted.value = true

    form.value = {
      name: "",
      email: "",
      message: "",
      data: false
    }

    console.log("Antwort:", res.data)

  } catch (err) {

    error.value = 'Fehler beim Versenden'
    console.error(err)

  }
}

const abfrage = () => {
  showConfirmToast.value = true
}

const confirmSubmission = async () => {

  await submitForm()

  toastMessage.value = "Ihre Kontaktanfrage wurde erfolgreich übermittelt."
  showToast.value = true

  setTimeout(() => showToast.value = false, 4000)

  showConfirmToast.value = false
}

const cancelSubmission = () => {
  showConfirmToast.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (showToast.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(toastMessage.value), 1))
      : _createCommentVNode("", true),
    (showConfirmToast.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", { class: "confirm-toast-box" }, [
            _cache[4] || (_cache[4] = _createElementVNode("p", null, " Sind Sie sicher, dass Sie die Anfrage absenden möchten? ", -1)),
            _createElementVNode("div", { class: "confirm-toast-buttons" }, [
              _createElementVNode("button", {
                class: "confirm-btn",
                onClick: confirmSubmission
              }, " Ja "),
              _createElementVNode("button", {
                class: "cancel-btn",
                onClick: cancelSubmission
              }, " Abbrechen ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "contact-header" }, [
      _createElementVNode("span", { class: "contact-badge" }, " Kontakt "),
      _createElementVNode("h1", null, " Wir sind für Sie da "),
      _createElementVNode("p", null, " Kontaktieren Sie uns für Fragen, Beratung oder weitere Informationen. ")
    ], -1)),
    _createElementVNode("div", _hoisted_4, [
      _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"contact-info\"><div class=\"info-card\"><h3>Standort 1 – Verwaltung</h3><p>Am Niedwald 53</p><p>65933 Frankfurt am Main</p><span> Postanschrift und Schriftverkehr </span></div><div class=\"info-card\"><h3>Standort 2 – Servicebüro</h3><p>Herxheimerstraße 17</p><p>60326 Frankfurt am Main</p><span> Kundenempfang und Beratung </span></div><div class=\"info-card\"><h3>Telefon</h3><a href=\"tel:+4906975009899\"> 069 7500 9899 </a></div></div>", 1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(abfrage, ["prevent"]),
          class: "contact-form"
        }, [
          _createElementVNode("div", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("label", null, "Name", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
              placeholder: "Ihr Name",
              required: ""
            }, null, 512), [
              [_vModelText, form.value.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[6] || (_cache[6] = _createElementVNode("label", null, "E-Mail", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "email",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.email) = $event)),
              placeholder: "Ihre E-Mail",
              required: ""
            }, null, 512), [
              [_vModelText, form.value.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[7] || (_cache[7] = _createElementVNode("label", null, "Nachricht", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.message) = $event)),
              placeholder: "Ihre Nachricht",
              required: ""
            }, null, 512), [
              [_vModelText, form.value.message]
            ])
          ]),
          _createElementVNode("label", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.data) = $event)),
              required: ""
            }, null, 512), [
              [_vModelCheckbox, form.value.data]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "custom-checkbox" }, null, -1)),
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "checkbox-text" }, [
              _createTextVNode(" Ich stimme der Verarbeitung meiner Daten gemäß "),
              _createElementVNode("a", {
                href: "/datenschutz",
                target: "_blank"
              }, "Datenschutzerklärung"),
              _createTextVNode(" zu. ")
            ], -1))
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("button", { type: "submit" }, " Nachricht senden ", -1))
        ], 32)
      ])
    ])
  ]))
}
}

})